/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter, applyFilters } from '@wordpress/hooks';
import {
	RangeControl,
	QueryControls,
	ToggleControl,
	TextControl,
} from '@wordpress/components';

/**
 * Inner dependencies.
 */
import Accordion from '../../../components/Accordion';
import AdvanceQueryControls from '../../../components/AdvanceQueryControls';
import blockInfo from '../constants';
const { hookPrefix, layouts } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-content`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/content`,
	( content, props ) => {
		const { attributes, setAttributes, updateInnerBlocks } = props;
		const { layout, columns, query } = attributes;

		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion
					tabs={ [
						{
							name: 'products',
							initialOpen: true,
							label: () => {
								return __( 'Products' );
							},
							cb: () => {
								return (
									<>
										{ layouts && (
											<div className="gutenify-template-browser">
												<h2>Templates</h2>

												<ul>
													{ layouts.map( ( template ) => {
														let classnames = 'gutenify-template-browser-item';
														if ( layout === template.name ) {
															classnames +=
																' gutenify-template-browser-item-active';
														}
														return (
															<li className={ classnames } key={ template.name }>
																<button
																	className={ `gutenify-template-browser-selector` }
																	onClick={ () => {
																		const data = {
																			layout: template.name,
																			socialIconAlign: template.socialIconAlign,
																			imageAlign: template.imageAlign,
																			titleAlign: template.titleAlign,
																		};
																		setAttributes( data );
																		updateInnerBlocks( template );
																	} }
																>
																	<img
																		src={ `${ window.gutenify_block_data.plugin_directory_url }/assets/images/post-slider-layouts/${ template.name }.png` }
																		alt={ template.name }
																	/>
																	<small>{ template.label }</small>
																</button>
															</li>
														);
													} ) }
												</ul>
												<hr />
											</div>
										) }

										<AdvanceQueryControls
											query={ query }
											postTypes={ [ 'product' ] }
											onChange={ ( val ) => {
												setAttributes( {
													query: { ...val },
												} );
											} }
											excludeFields={ [ 'authors' ] }
										/>
										<RangeControl
											value={ columns }
											label={ __( 'Columns' ) }
											min={ 1 }
											max={ 5 }
											step={ 1 }
											onChange={ ( value ) => {
												setAttributes( { columns: value } );
											} }
										/>
									</>
								);
							},
						},
						{
							name: 'slider-options',
							label: () => {
								return __( 'Slider' );
							},
							cb: () => <>{ applyFilters( `gutenify--${ hookPrefix }--inspector--tab-content--slider`, [], props ) }</>,
						},
					] }
				/>
			</Fragment>,
		];
	}
);
